import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';

export const useCognitoFeatureFlagEnabled = () => {
  const { market } = useSelector((state: RootState) => state.intl);
  const maintenanceFlagName = `cognito-authentication-${market.toLowerCase()}`;
  return useFeatureFlagEnabled(maintenanceFlagName);
};
